import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getintraLabProgramHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({
				path: "intralaboratoryprogram",
				...action.payload,
			}),
		);
		yield put({
			type: types.GET_INTRA_LAB_PROGRAM_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_INTRA_LAB_PROGRAM_ERROR,
			payload,
		});
	}
}

export function* getintraLabProgramWatcherSaga() {
	yield takeLatest(
		types.GET_INTRA_LAB_PROGRAM_START,
		getintraLabProgramHandlerSaga,
	);
}

//create

//delete

function* deleteintraLabProgramHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("intralaboratoryprogram", action.payload),
		);
		yield put({
			type: types.DELETE_INTRA_LAB_PROGRAM_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_INTRA_LAB_PROGRAM_ERROR,
			payload,
		});
	}
}

export function* deleteintraLabProgramWatcherSaga() {
	yield takeLatest(
		types.DELETE_INTRA_LAB_PROGRAM_START,
		deleteintraLabProgramHandlerSaga,
	);
}

//update
